import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import List from '@mui/material/List';
import styles from './styles';
import { Divider, Typography, Grid, IconButton } from '@mui/material';
import TreeView from '../../components/TreeView';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

class SideNav extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            isOpen: props.disableCollapseButton === true ? true : (localStorage.getItem("sideNavCollapseStatus") === 'false' ? false : true)
        }
    }

    onCollapse = () => {
        const { isOpen } = this.state;
        this.setState({ isOpen: !isOpen });
        localStorage.setItem("sideNavCollapseStatus", !isOpen ? "true" : "false");
    }

    render() {
        const { classes, title, headerButton, tree, width, onNodeClick, inputSearch, disableCollapseButton } = this.props;
        const { isOpen } = this.state;

        return (
            <Grid item xs={2} xl={2} style={{
                height: '100%',
                ...(isOpen
                    ? width
                        ? { width, minWidth: width, maxWidth: width, flex: `0 0 ${width}px` }
                        : { minWidth: 270 }
                    : { width: 50, maxWidth: 50, flex: '0 0 50px', overflow: 'hidden', minWidth: 50 })
            }}>
                <List component="nav" className={classes.root} disablePadding style={{ paddingTop: 5 }}>

                    {title && <div className={classes.subheader}>
                        <Typography align='center' variant="h6" style={{ lineHeight: '2.16667em', width: '100%' }}> {title} </Typography>
                    </div>}

                    {headerButton && <>
                        <div className={classes.buttons}>
                            {headerButton}
                        </div>
                        <Divider />
                    </>}

                    {disableCollapseButton === true ? null : <>
                        <div className={classes.buttons} style={{ justifyContent: 'end', paddingRight: 11, height: 35 }}>
                            {isOpen ?
                                <IconButton
                                    size='small'
                                    onClick={this.onCollapse} color="inherit">
                                    <KeyboardDoubleArrowLeftIcon fontSize='medium' sx={{ color: (theme) => theme.palette.mode === 'dark' ? 'white' : 'black' }} />
                                </IconButton> :
                                <IconButton
                                    size='small'
                                    onClick={this.onCollapse} color="inherit">
                                    <KeyboardDoubleArrowRightIcon fontSize='medium' sx={{ color: (theme) => theme.palette.mode === 'dark' ? 'white' : 'black' }} />
                                </IconButton>}
                        </div>
                        <Divider sx={{ marginBottom: 1 }} />
                    </>}

                    {inputSearch}
                    {inputSearch ? (<Divider />) : (null)}

                    <div style={{ padding: '0px 10px', width: '100%', minWidth: 0, boxSizing: 'border-box', overflow: 'hidden', ...(isOpen ? {} : { display: 'none' }) }}>
                        <TreeView tree={tree} onNodeClick={onNodeClick} />
                    </div>
                </List>
            </Grid>
        );
    }
}

SideNav.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SideNav);